'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef } from 'react';

// Sanitize string to remove invalid characters that cause DOMException in some browsers
function sanitizeForDOM(str: string): string {
  if (!str) return '';
  try {
    // Remove null bytes, control characters, and other problematic Unicode characters
    return str.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '').replace(/[\x80-\x9F]/g, '').replace(/\uFFFE|\uFFFF/g, '');
  } catch {
    return '';
  }
}
interface TweetEmbedProps {
  embedJs: string;
}
function decodeEmbedJs(embedJs: string): string {
  try {
    return atob(embedJs);
  } catch {
    try {
      return decodeURIComponent(embedJs);
    } catch {
      return embedJs;
    }
  }
}
export default function TweetEmbed(t0) {
  const $ = _c(7);
  const {
    embedJs
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== embedJs) {
    const decodedContent = decodeEmbedJs(embedJs);
    t1 = sanitizeForDOM(decodedContent);
    $[0] = embedJs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const embedHtml = t1;
  let t2;
  let t3;
  if ($[2] !== embedHtml) {
    t2 = () => {
      const container = containerRef.current;
      if (!embedHtml || !container) {
        return;
      }
      const loadTweet = () => {
        if (window.twttr?.widgets) {
          window.twttr.widgets.load(container);
          return true;
        }
        return false;
      };
      if (loadTweet()) {
        return;
      }
      const existingScript = document.querySelector("script[src*=\"platform.twitter.com/widgets.js\"], script[src*=\"platform.x.com/widgets.js\"]");
      if (existingScript) {
        existingScript.addEventListener("load", loadTweet, {
          once: true
        });
      } else {
        const script = document.createElement("script");
        script.src = "https://platform.x.com/widgets.js";
        script.charset = "utf-8";
        script.async = true;
        script.addEventListener("load", loadTweet, {
          once: true
        });
        document.head.appendChild(script);
      }
      const checkTwttr = setInterval(() => {
        if (loadTweet() && checkTwttr) {
          clearInterval(checkTwttr);
        }
      }, 200);
      return () => {
        clearInterval(checkTwttr);
        existingScript?.removeEventListener("load", loadTweet);
      };
    };
    t3 = [embedHtml];
    $[2] = embedHtml;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== embedHtml) {
    t4 = <div ref={containerRef} className="mb-4" dangerouslySetInnerHTML={{
      __html: embedHtml
    }} />;
    $[5] = embedHtml;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}